/**
 * Created by Ivan on 16.04.2024
 */

const StickersCollection = function (options) {
    cleverapps.EventEmitter.call(this);

    this.isPrizeCollected = options.isPrizeCollected;
    this.isCompleted = false;

    this.index = options.index;

    this.createStickers(options);

    this.title = `Collection.${this.index}.Title`;
    this.icon = this.getIcon();
};

StickersCollection.prototype = Object.create(cleverapps.EventEmitter.prototype);
StickersCollection.prototype.constructor = StickersCollection;

StickersCollection.prototype.getIcon = function () {
    return bundles.stickers_book_window.frames[`collection${this.index}_png`];
};

StickersCollection.prototype.createStickers = function (options) {
    this.stickers = [];

    options.stickers.forEach((state, i) => {
        const title = `Sticker.${this.index}.${i}.Title`;
        const sticker = new Sticker({
            collection: this,
            state,
            image: bundles[StickersCollection.getCollectionBundle(this.index)].frames[`sticker_${i}_png`],
            rarity: this.calculateRarity(i),
            title,
            attention: i < options.attention.length ? options.attention[i] : false
        });
        sticker.on("update", this.onStickerUpdate.bind(this));
        this.stickers.push(sticker);
    });

    this.onStickerUpdate();
};

StickersCollection.prototype.getInfo = function () {
    return {
        isPrizeCollected: this.isPrizeCollected,
        stickers: this.stickers.map((sticker) => sticker.getState())
    };
};

StickersCollection.prototype.onPrizeCollect = function () {
    this.isPrizeCollected = true;
    cleverapps.stickersBook.save();
    this.trigger("update");
};

StickersCollection.prototype.onStickerUpdate = function () {
    let isCompleted = true;

    for (let i = 0; i < this.stickers.length; i++) {
        if (StickersBook.isPuzzle() && this.stickers[i].hasAttention()) {
            isCompleted = false;
        }

        if (this.stickers[i].getState() === Sticker.STATE_CLOSED) {
            isCompleted = false;
        }
    }

    if (isCompleted) {
        this.setCompleted();
    }

    this.trigger("update");
};

StickersCollection.prototype.setCompleted = function () {
    this.isCompleted = true;
    this.trigger("complete");
};

StickersCollection.prototype.getOpenedStickersAmount = function (withoutAttention) {
    return this.stickers.filter((sticker) => {
        if (StickersBook.isPuzzle() && !withoutAttention) {
            return sticker.getState() === Sticker.STATE_OPENED && !sticker.hasAttention();
        } 
        return sticker.getState() === Sticker.STATE_OPENED;
    }).length;
};

StickersCollection.prototype.getAvailableLevel = function () {
    let availableLevel = cleverapps.config.availables.STICKERS_BOOK.level;
    for (let i = 0; i < this.index; i++) {
        if (availableLevel < 13.2) {
            availableLevel += 2.666;
        } else {
            availableLevel += 5.333;
        }
    }

    return cleverapps.humanReadableNumber({ floatLevel: availableLevel });
};

StickersCollection.prototype.isAvailable = function () {
    const currentLevel = levels.user.getVirtualLevel();
    const availableLevel = this.getAvailableLevel();
    return currentLevel >= availableLevel;
};

StickersCollection.prototype.isCollected = function () {
    return this.getOpenedStickersAmount(true) === StickersCollection.STICKERS_IN_COLLECTION;
};

StickersCollection.prototype.hasAttention = function () {
    return this.stickers.filter((sticker) => sticker.hasAttention()).length;
};

StickersCollection.prototype.getAttentionInfo = function () {
    return this.stickers.map((sticker) => sticker.hasAttention());
};

StickersCollection.prototype.updateAttention = function (data) {
    this.stickers.forEach((sticker, index) => {
        sticker.setAttention(data[index]);
    });
};

StickersCollection.prototype.resetAttention = function () {
    this.stickers.forEach((sticker) => {
        sticker.setAttention(false);
    });
    this.trigger("hideAttention");
};

StickersCollection.prototype.calculateRarity = function (stickerIndex) {
    return stickerIndex < StickersCollection.RARE_STICKERS_CONFIG[this.index % StickersCollection.RARE_STICKERS_CONFIG.length]
        ? StickersCollection.RARITIES[1] : StickersCollection.RARITIES[0];
};

StickersCollection.getCollectionBundle = function (index) {
    return `collection_${index}`;
};

StickersCollection.STICKERS_IN_COLLECTION = 9;

StickersCollection.REGULAR_POINTS = 5;
StickersCollection.RARE_POINTS = 25;
StickersCollection.GOAL_POINTS = 200;

StickersCollection.RARITIES = ["regular", "rare"];

StickersCollection.RARE_STICKERS_CONFIG = [
    3,
    4,
    4,
    3,
    4,
    3,
    5,
    4,
    5,
    5
];

StickersCollection.COLLECTION_CONFIG = [
    [7, 2, 0, 0, 0, 0],
    [7, 1, 1, 0, 0, 0],
    [5, 3, 1, 0, 0, 0],
    [3, 4, 1, 1, 0, 0],
    [2, 4, 1, 1, 1, 0],
    [1, 3, 2, 1, 1, 1],
    [0, 3, 2, 1, 2, 1],
    [0, 2, 2, 2, 1, 2],
    [0, 1, 3, 1, 2, 2],
    [0, 0, 3, 2, 1, 3],
    [0, 0, 2, 2, 2, 3],
    [0, 0, 0, 4, 2, 3]
];